import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getOrderDetailsStart } from './../redux/Orders/orders.actions';
import { useDispatch, useSelector } from 'react-redux';
import OrderDetails from './../components/OrderDetails';
import DashAuthWrapper from '../components/DashAuthWrapper'
import {format} from 'date-fns'

const mapState = ({ ordersData }) => ({
  orderDetails: ordersData.orderDetails
});

const Order = () => {
  const { orderID } = useParams();
  const dispatch = useDispatch();
  const { orderDetails } = useSelector(mapState);
  const { orderTotal, orderCreatedDate } = orderDetails;

  useEffect(() => {

    dispatch(
      getOrderDetailsStart(orderID)
    );
      // eslint-disable-next-line
  }, []);

  return (
    <div>
      <DashAuthWrapper>
        <h2>
          Order ID: #{orderID}
        </h2>
        {orderCreatedDate &&
        <h3 className="pb-5">Date: {format(orderCreatedDate.toDate(), 'MMM dd, yyyy ')}</h3>
        }
        <OrderDetails order={orderDetails} />

        <h3 className="pt-5">
          Total: ${orderTotal}
        </h3>
      </DashAuthWrapper>
    </div>
  )

}

export default Order;